<script>
  import { onMount, onDestroy } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import Events from '../lib/events.js';
  import { show_message } from '../lib/flash.ts';
  import APIClient from '../state-charts/api-client';
  import Dialog from '../lib/components/Dialog.svelte';
  import InputWithValidation from '../lib/components/InputField.svelte';

  export let team;

  let title = t9n(TS.ORDERER_TEAMS_DETAILS_TITLE);
  let name_title = t9n(TS.ORDERER_TEAMS_TEAM_NAME_TITLE);
  let code_title = t9n(TS.ORDERER_TEAMS_TEAM_CODE_TITLE);
  let user_label = t9n(TS.ORDERER_TEAMS_USER_LABEL);
  let add_user_text = t9n(TS.ORDERER_TEAMS_ADD_USER_TEXT);
  let delete_team_label = t9n(TS.ORDERER_TEAMS_DELETE_TEAM_LABEL);
  let team_not_empty_error = t9n(TS.ORDERER_TEAMS_TEAM_NOT_EMPTY_ERROR);
  let add_label = t9n(TS.ORDERER_TEAMS_ADD_LABEL);
  let remove_label = t9n(TS.ORDERER_TEAMS_REMOVE_LABEL);
  let close_label = t9n(TS.ORDERER_TEAMS_CLOSE_LABEL);
  let cancel_label = t9n(TS.ORDERER_TEAMS_CANCEL_LABEL);
  let confirm_title = t9n(TS.ORDERER_TEAMS_CONFIRM_TITLE);
  let team_confirm_text = t9n(TS.ORDERER_TEAMS_TEAM_CONFIRM_TEXT);
  let user_confirm_text = t9n(TS.ORDERER_TEAMS_USER_CONFIRM_TEXT);

  let dialog;
  let users;
  let email;
  let team_delete_confirm_dialog;
  let user_delete_confirm_dialog;
  let wait_api = false;

  const confirm_team_deletion = () => {
    let target = document.querySelector('#confirm-dialog');

    target.innerHTML = '';

    team_delete_confirm_dialog = new Dialog({
      target: target,
      props: {
        id: 'user-delete-confirm',
        title: confirm_title,
        content: team_confirm_text,
        modal: true,
        buttons: [
          {
            label: cancel_label,
            action: () => {
              team_delete_confirm_dialog.close();
            },
            classes: [],
          },
          {
            label: remove_label,
            action: async () => {
              await delete_team()
            },
            classes: [],
          },
        ],
      },
    });

    team_delete_confirm_dialog.open();
  };

  const confirm_user_removal = user_id => {
    let target = document.querySelector('#confirm-dialog');

    target.innerHTML = '';

    user_delete_confirm_dialog = new Dialog({
      target: target,
      props: {
        id: 'user-delete-confirm',
        title: confirm_title,
        content: user_confirm_text,
        modal: true,
        buttons: [
          {
            label: cancel_label,
            action: () => {
              user_delete_confirm_dialog.close();
            },
            classes: [],
          },
          {
            label: remove_label,
            action: async () => {
              await remove_user(user_id)
            },
            classes: [],
          },
        ],
      },
    });

    user_delete_confirm_dialog.open();
  };

  const get_users = async () => {
    const data = await APIClient.get_team_users(team.team_id);
    users = data.users;
  };

  const wait_for_sec = (sec) => {
    wait_api = true;
    setTimeout(function() {
      wait_api = false;
    }, sec);
  }

  const add_user = async () => {
    const data = {
      email: email,
      team_id: team.team_id,
    };
    wait_for_sec(1000)
    let result = await APIClient.add_team_user(data);
    wait_api = false;
    if (!!result) {
      email = null;
      await get_users();
    }
  };

  const remove_user = async user_id => {
    user_delete_confirm_dialog.close();

    const data = {
      user_id: user_id,
      team_id: team.team_id,
    };
    // TODO: show confirmation dialog
    await APIClient.remove_team_user(data);
    await get_users();
  };

  const delete_team = async () => {
    team_delete_confirm_dialog.close();

    if (users.length > 0) {
      return show_message(team_not_empty_error, 'error');
    }

    const data = { team_id: team.team_id };

    await APIClient.delete_team(data);
    Events.dispatch('ordererteamdeleted', { team });
    dialog.close();
  };

  onMount(async () => {
    await get_users();
    dialog = new MDCDialog(document.querySelector('#edit_team_dialog'));
    dialog.open();
  });

  onDestroy(() => {
    dialog = null;
  });
</script>

<div id="edit_team_dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="dialog"
      aria-modal="true"
      aria-labelledby="edit_team_dialog_title"
      aria-describedby="edit-team-dialog-content">
      <h2
        class="mdc-dialog__title"
        style="text-align: center"
        id="edit_team_dialog_title">
        {title}
      </h2>

      <div
        class="mdc-dialog__content"
        style="padding: 20px"
        id="edit_team_dialog_content">

        <div style="display: flex; justify-content: space-between">
          <InputWithValidation
            id="input-user-email"
            type="email"
            name="email"
            width='350px'
            margin_bottom={'0px'}
            label={'Email'}
            bind:value={email}
            is_tooltip_default={true}
            tooltip_default_text={add_user_text} />
          <button
            style="margin-left: 10px; align-self: center"
            disabled={wait_api}
            class="mdc-button mdc-button--oval mdc-button--raised"
            on:click|stopPropagation|preventDefault={async () => {await add_user()} }>
            <span class="mdc-button__ripple" />
            {add_label}
          </button>
        </div>

        <!-- this max-height here sets the table height to ~5 users before scroll-->
        <div
          class="mdc-data-table table-min-height fade-in"
          style="max-height: 400px; width: 100%; overflow-x: scroll; margin-top: 10px;">
          <table
            id="public-profile-info"
            class="mdc-data-table__table table transparent fitscreen">
            <tbody class="mdc-data-table__content">

            <tr class="city mdc-data-table-bold mdc-data-table__row">
              <td>
                <b class="pull-right">{name_title}</b>
              </td>
              <td class="content">{team.name}</td>
              <td />
            </tr>

            <tr class="description mdc-data-table-bold mdc-data-table__row">
              <td>
                <b class="pull-right">{code_title}</b>
              </td>
              <td class="content">
                {#if !!team.code}
                  {team.code}
                {/if}

              </td>
              <td />
            </tr>

            <!-- Each loop for users in team -->
            {#if users}
              {#each users as user}
                <tr class="postal-code mdc-data-table__row">
                  <td>
                    <b class="pull-right">{user_label}</b>
                  </td>
                  <td class="content dialog-td-emails">
                    <strong>{user.first_name} {user.last_name}</strong><br>
                    {user.email}
                  </td>
                  <td style="text-align: right">
                    <button
                      class="mdc-button hover remove-dialog-button"
                      style="color: #bb0000;"
                      on:click|stopPropagation|preventDefault={() => confirm_user_removal(user.user_id)}>
                      {remove_label}
                    </button>
                  </td>
                </tr>
              {/each}
            {/if}
            </tbody>
          </table>
        </div>
      </div>

      <footer
        class="mdc-dialog__actions"
        style="justify-content: space-between;">
        <button
          id="delete_team_button"
          class="mdc-button mdc-button--unelevated"
          style="background-color: #bb0000; margin-right: 10px"
          on:click|stopPropagation|preventDefault={confirm_team_deletion}>
          {delete_team_label}
        </button>

        <button
          id="edit_team_close_button"
          class="mdc-button"
          on:click|stopPropagation|preventDefault={() => dialog.close()}>
          {close_label}
        </button>
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<!-- Hidden confirm dialog -->
<div id="confirm-dialog" />

<style type="text/scss">
  /* Table
    **************/

  /*
  th {
    font-weight: 800;
    color: #616161;
    text-align: left;
    font-size: 15px;
  }

  td {
    font-weight: 500;
    color: #616161;
  }

  .mdc-data-table__row {
    border-top-style: dashed;
  }

  table.fitscreen {
    table-layout: fixed;
  }

  .table {
    color: #333;
    width: 100%;
    border: 0;
    border-radius: 0;
    overflow-x: auto;
    margin-top: 10px;
    margin-bottom: 32px;
    background: aliceblue;
  }
*/
  .table thead > tr > th,
  .table tbody > tr > th,
  .table tfoot > tr > th,
  .table thead > tr > td,
  .table tbody > tr > td,
  .table tfoot > tr > td {
    padding: 10px;
  }

  .add-button {
    height: 50px;
  }

  .remove-dialog-button {
    height: 20px;
  }

  .dialog-td-emails {
    word-wrap: break-word;
    white-space: normal;
  }

  .mdc-data-table__content tr {
    cursor: pointer;
  }

  .mdc-data-table__content tr.mdc-data-table-bold,
  .mdc-data-table__content tr.mdc-data-table-bold td {
    cursor: context-menu;
  }

  .mdc-button--oval {
    border-radius: 40px;
    background-color: var(--mdc-theme-primary);
    color: white;
    height: 48px;
    padding-left: 15px;
    padding-right: 15px;
  }

  /* Tooltip
    *******************************************************/

  .tooltip-default {
    position: relative;
    font-size: 12px;
    /*top: -60px;*/
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    /*position: absolute;*/
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    display: block;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
  }

  .tooltip-default .tooltip-text::before {
    content: ' ';
    position: relative;
    top: -30px;
    left: 95%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #018786 transparent;
  }

  .fade-in-long {
    animation: transition_in 2.5s;
  }

  .mdc-data-table {
    overflow-x: hidden;
  }

  .mdc-data-table-bold {
    background-color: blanchedalmond;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .wrapper {
      width: 900px;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
      padding: 30px;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapper {
      width: 90%;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .wrapper {
      /*width: 100%;*/
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }

    td {
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>
